import { Button, CircularProgress, TextField } from "@mui/material";
import Box from "elements/Box";
import { ApiRequest } from "GlobalFunctions";
import { useState, useEffect, useMemo } from "react";
import { useSnackbar } from "notistack";

import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const defaultValues = {
  title: "",
  description: "",
  keywords: "",
  min_rating_stars: 4,
  terms_content: "",
  preferente_terms: "",
};

export default function Settings(props: any) {
  const [formValues, setFormValues] = useState(defaultValues);
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const modules = useMemo(() => ({
    toolbar: [
      [{ 'header': [1, 2, 3, false] }],
      ['bold', 'italic', 'underline'],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      ['link'],
      ['clean']
    ]
  }), []);

  const handleSubmit = async () => {
    setLoading(true);
    await ApiRequest({
      url: "/settings/update",
      method: "POST",
      body: formValues,
      setResponse: (response: any) => {
        setLoading(false);
        enqueueSnackbar("Datos guardados", { variant: "success" });
      },
    });
    setLoading(false);
  };

  const loadList = async () => {
    ApiRequest({
      url: "/settings/details",
      method: "GET",
      setResponse: (response: any) => {
        setFormValues({ ...defaultValues, ...response.seo });
      },
    });
  };

  useEffect(() => {
    loadList();
  }, []);

  return (
    <div className="content">
      <div className="blog_title_row">
        <h2 className="titles">Configuración</h2>
      </div>

      <Box>
        <h2>SEO</h2>
        <TextField
          label="Título"
          value={formValues.title}
          onChange={(e) => setFormValues({ ...formValues, title: e.target.value })}
          variant="outlined"
          fullWidth
        />
        <TextField
          label="Descripción"
          value={formValues.description}
          multiline
          onChange={(e) => setFormValues({ ...formValues, description: e.target.value })}
          variant="outlined"
          fullWidth
        />
        <TextField
          label="Palabras clave"
          value={formValues.keywords}
          onChange={(e) => setFormValues({ ...formValues, keywords: e.target.value })}
          variant="outlined"
          fullWidth
        />
      </Box>

      <Box style={{ marginTop: '24px' }}>
        <h2>Calificaciones</h2>
        <p style={{ color: '#666', marginBottom: '12px' }}>
          Estrellas mínimas para aprobar automáticamente una calificación (1–5).
        </p>
        <TextField
          label="Estrellas mínimas para auto-aprobar"
          type="number"
          value={formValues.min_rating_stars}
          onChange={(e) => setFormValues({ ...formValues, min_rating_stars: Number(e.target.value) })}
          variant="outlined"
          inputProps={{ min: 1, max: 5 }}
          style={{ maxWidth: 300 }}
        />
      </Box>

      <Box style={{ marginTop: '24px' }}>
        <h2>Términos y Condiciones</h2>
        <p style={{ color: '#666', marginBottom: '12px' }}>
          Contenido visible en la página /terminos.
        </p>
        <div style={{ marginBottom: '60px' }}>
          <ReactQuill
            value={formValues.terms_content}
            onChange={(content) => setFormValues({ ...formValues, terms_content: content })}
            style={{ height: '400px', marginBottom: '50px' }}
            modules={modules}
            theme="snow"
          />
        </div>
      </Box>

      <Box style={{ marginTop: '24px' }}>
        <h2>Condiciones de Cobro por Derivación ($10.000)</h2>
        <p style={{ color: '#666', marginBottom: '12px' }}>
          Este texto se muestra a los kinesiólogos al registrarse y al aceptar el cobro por derivación en su perfil.
        </p>
        <div style={{ marginBottom: '60px' }}>
          <ReactQuill
            value={formValues.preferente_terms}
            onChange={(content) => setFormValues({ ...formValues, preferente_terms: content })}
            style={{ height: '300px', marginBottom: '50px' }}
            modules={modules}
            theme="snow"
          />
        </div>
      </Box>

      <div style={{ marginTop: '24px' }}>
        <Button
          onClick={handleSubmit}
          variant="contained"
          disabled={loading}
          startIcon={loading && <CircularProgress size={20} />}
        >
          {loading ? "Guardando..." : "Guardar todo"}
        </Button>
      </div>
    </div>
  );
}
